import React, { Component } from "react";
import { Api } from "../../utils/api";
import Chart from 'react-apexcharts';

class NewRequests extends Component {

  constructor() {
    super();
    this.api = new Api();
  }


  state = {
    chartOptions: {
      title: {
        text: 'Registo de Pedidos Novos - Formulário de Ajuda',
        align: 'center',
        margin: 40,
        style: {
          fontSize:  '18px',
          fontWeight:  'bold',
          color:  '#263238'
        }
      },
      labels: [
        'Já atribuídos a uma consultora', 
        'Por atribuir'
      ],
      legend: {
        show: true,
        position: "bottom",
        fontSize: "13px"
      },
     colors:['#A9A9A9', '#20B2AA']
    }
  }

  render() {

    return (
      <div class="requests-chart">
        {this.props.newRequests && (
          <Chart 
            title={this.state.title}
            options={this.state.chartOptions} 
            series={[this.props.newRequests[0].todays_not_new, this.props.newRequests[0].todays_new_requests]}
            type="pie" 
            width="480"
          /> 
        )}
      </div>  
    );
  }
}
export default NewRequests;
